import { render, staticRenderFns } from "./cumulative.vue?vue&type=template&id=3028ce26&scoped=true"
import script from "./cumulative.vue?vue&type=script&lang=js"
export * from "./cumulative.vue?vue&type=script&lang=js"
import style0 from "@/utils/style/table.css?vue&type=style&index=0&id=3028ce26&prod&scoped=true&lang=css&external"
import style1 from "./cumulative.vue?vue&type=style&index=1&id=3028ce26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3028ce26",
  null
  
)

export default component.exports